import { render } from "./ProjectProcureImageModal.vue?vue&type=template&id=3387b576&scoped=true&ts=true"
import script from "./ProjectProcureImageModal.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureImageModal.ts?vue&type=script&lang=ts"

import "./ProjectProcureImageModal.scss?vue&type=style&index=0&id=3387b576&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3387b576"]])

export default __exports__